// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__n31PZ","col":"styles_col__28sED"};